import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  amountTitle: {
    id: 'donater.form.amount.title',
    defaultMessage: 'Amount',
  },
  min: {
    id: 'donater.form.amount.min',
    defaultMessage: 'Min.',
  },
  minError: {
    id: 'donater.form.amount.min_error',
    defaultMessage: 'Min. amount is {amount}',
  },
  commonError: {
    id: 'donater.form.amount.common_error_text',
    defaultMessage: 'Unable to process your request. Please try to increase the amount or change the currency.',
  },
})
